import { useState } from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import AddLeadForm from '../forms/profile/AddLeadForm';

interface AddLeadDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const AddLeadDialog = ({ open, setOpen }: AddLeadDialogProps) => {
  const [createLeadError, setCreateLeadError] = useState<string | null>(null);

  const handleCloseDialog = (): void => {
    setCreateLeadError(null);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        setOpen(isOpen);
        if (!isOpen) {
          handleCloseDialog();
          return;
        }
        setCreateLeadError(null);
      }}
    >
      <DialogContent className="gap-0 p-0">
        <DialogHeader className="border-b border-border p-4">
          <DialogTitle>Add Lead</DialogTitle>
        </DialogHeader>
        {createLeadError && (
          <p className="px-5 pt-4 text-sm text-destructive">
            {createLeadError}
          </p>
        )}
        <AddLeadForm
          closeDialog={handleCloseDialog}
          onCreateLeadError={setCreateLeadError}
          onClearCreateLeadError={() => setCreateLeadError(null)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddLeadDialog;
